import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";

export const AddOrganization = () => {

    const { apipath, logout, goBack } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [isLoading, setIsLoading] = useState(false);
    const userType = localStorage.getItem('userType');
    const [activeTab, setActiveTab] = useState("Organization");

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        state: "",
        city: "",
        pincode: "",
        address: "",
    });

    const [errors, setErrors] = useState({});
    // const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // const togglePasswordVisibility = () => {
    //     setShowPassword(!showPassword);
    // };

    const validate = () => {
        let tempErrors = {};
        if (!formData.name) tempErrors.name = "Name is required";
        if (!formData.email) tempErrors.email = "Email is required";
        if (!/\S+@\S+\.\S+/.test(formData.email))
            tempErrors.email = "Email is invalid";
        if (!formData.phone) tempErrors.phone = "Phone is required";
        if (!/^\d{10}$/.test(formData.phone))
            tempErrors.phone = "Phone number must be 10 digits";
        if (!formData.state) tempErrors.state = "State is required";
        if (!formData.city) tempErrors.city = "City is required";
        if (!formData.pincode) tempErrors.pincode = "Pincode is required";
        if (!/^\d{6}$/.test(formData.pincode))
            tempErrors.pincode = "Pincode must be 6 digits";
        if (!formData.address) tempErrors.address = "Address is required";
        // if (!formData.password) tempErrors.password = "Password is required";
        // if (formData.password.length < 6)
        //     tempErrors.password = "Password must be at least 6 characters long";

        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setIsLoading(true);
            // console.log(formData);
            try {
                const response = await axios.post(
                    apipath + '/add_organization', formData,
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    logout();
                }
                else if (response.data.status === "false") {
                    if(response.data.errors){
                        const err = Object.keys(response.data.errors)[0];
                        iziToast.error({
                            message: response.data.errors[err],
                            position: "topCenter"
                        });
                    }
                    else{
                        iziToast.error({
                            message: response.data.message,
                            position: "topCenter"
                        });
                    }
                }
                else {
                    iziToast.success({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    navigate('/users');
                }
            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }
            }
            finally {
                setIsLoading(false);
            }
            // Process the form data here (e.g., send it to the server)
        }
    };


    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
                Loading...
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"users"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                            <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={()=>goBack()}></i>Add Organization</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/users`}><span class={`md:ml-5 ml-2 ${activeTab === 'Organization' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Organizations
                                </span></Link>
                                <Link to={`/students`}><span class={`md:ml-5 ml-2 ${activeTab === 'Student' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Students
                                </span></Link>
                            </div> */}
                        </div>
                        {/* <div class="bg-gradient-to-r from-blue-700 to-blue-700 px-4 py-2 shadow text-base text-white">
                            <h3 class="font-medium pl-2">Users</h3>
                        </div> */}
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-2">
                            <form onSubmit={handleSubmit} className=" mx-auto p-4 space-y-6 bg-white rounded-lg shadow-lg">
                                <h2 className="text-2xl font-bold text-teal-800 text-center">Add Organization</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {/* Name */}
                                    <div>
                                        <label className="block font-medium">Organization Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
                                    </div>

                                    {/* Email */}
                                    <div>
                                        <label className="block font-medium">Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.email && (
                                            <p className="text-red-500 text-sm">{errors.email}</p>
                                        )}
                                    </div>

                                    {/* Phone */}
                                    <div>
                                        <label className="block font-medium">Phone</label>
                                        <input
                                            type="text"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.phone && (
                                            <p className="text-red-500 text-sm">{errors.phone}</p>
                                        )}
                                    </div>

                                    {/* State */}
                                    <div>
                                        <label className="block font-medium">State</label>
                                        <input
                                            type="text"
                                            name="state"
                                            value={formData.state}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.state && (
                                            <p className="text-red-500 text-sm">{errors.state}</p>
                                        )}
                                    </div>

                                    {/* City */}
                                    <div>
                                        <label className="block font-medium">City</label>
                                        <input
                                            type="text"
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.city && (
                                            <p className="text-red-500 text-sm">{errors.city}</p>
                                        )}
                                    </div>

                                    {/* Pincode */}
                                    <div>
                                        <label className="block font-medium">Pincode</label>
                                        <input
                                            type="text"
                                            name="pincode"
                                            value={formData.pincode}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.pincode && (
                                            <p className="text-red-500 text-sm">{errors.pincode}</p>
                                        )}
                                    </div>

                                    {/* Address */}
                                    <div className="md:col-span-2">
                                        <label className="block font-medium">Address</label>
                                        <textarea
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.address && (
                                            <p className="text-red-500 text-sm">{errors.address}</p>
                                        )}
                                    </div>

                                    {/* Password */}
                                    {/* <div className="md:col-span-2">
                                        <label className="block font-medium">Password</label>
                                        <div className="relative">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                className="w-full border px-3 py-2 rounded focus:outline-none"
                                            />
                                            <button
                                                type="button"
                                                onClick={togglePasswordVisibility}
                                                className="absolute inset-y-0 right-0 px-4 text-gray-600"
                                            >
                                                {showPassword ? <><i className="fa fa-eye-slash" title="hide"></i></> : <><i className="fa fa-eye" title="show"></i></>}
                                            </button>
                                        </div>
                                        {errors.password && (
                                            <p className="text-red-500 text-sm">{errors.password}</p>
                                        )}
                                    </div> */}
                                </div>

                                <div className="text-center">
                                    <button type="submit" className="bg-teal-500 text-white px-6 py-2 rounded-md hover:bg-teal-600">
                                        Create Organization
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};